import { Tables } from '@typings';
import cx from 'classnames';
import { WithChildren } from 'react';

import styles from '../Table.module.scss';

const INSET_PADDING = 24;

export const TableRow = ({
  children,
  depth,
  variant = 'white',
  isExpanded = false,
  isExpandedRow = false,
}: WithChildren<Tables.TableRowProps>) => {
  const insetStyle = { '--row-inset': `${(depth ?? 0) * INSET_PADDING}px` };

  return (
    <tr
      style={insetStyle as React.CSSProperties}
      className={cx(styles.row, `sticky row-level-${depth}`, {
        [styles.expanded]: isExpanded,
        [styles.expandedRow]: isExpandedRow,
        [styles.white]: variant === 'white',
        [styles.gray]: variant === 'gray',
      })}
    >
      {children}
    </tr>
  );
};
